<script>
  import { createEventDispatcher } from 'svelte'
  import Loader from '../Loader.svelte'

  export let page
  export let totalPages
  export let isLoadingMore

  const dispatch = createEventDispatcher()

  function handleLoadMoreClick (e) {
    e.preventDefault()
    dispatch('loadMoreClick')
  }
</script>

<div class="mt-5 min-h-[26px]">
  {#if isLoadingMore}
    <Loader />
  {:else}
    {#if page < totalPages}
      <button on:click={handleLoadMoreClick} class="font-bold border-b-2 border-black pb-0.5">Load More</button>
    {/if}
  {/if}
</div>